export default {
  "1": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["wczoraj"])},
  "2": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Czat"])}
}